import { ExtendedApiObject } from '@bpd-library/utilities';
import { translateItem } from '@utilities/hooks';

const getMapCardTitle = async (apiObject: ExtendedApiObject) => {
    switch (apiObject.objectType) {
        case 'constructionNumber':
            const houseTypeTranslationKey = `PropertyTypeName-${apiObject.propertyType?.houseType?.toLowerCase()}`;
            const houseTypeTranslated = await translateItem(houseTypeTranslationKey);
            return `${houseTypeTranslated} ${apiObject.identifier}`;
        case 'propertyType':
            return `${apiObject.name} ${apiObject.projectPhaseName || ''}`;
        case 'apartmentBuilding':
            return apiObject.displayName || '';
        case 'projectPhase':
            return apiObject.name || '';
        case 'district':
            return apiObject.name || '';
        case 'areaProject':
            return apiObject.name || '';
    }
};

export { getMapCardTitle };
